module.exports = __webpack_public_path__ + "static/media/studio-etc20.b81266e0.png";